'use strict';

// exposing modules
exports.AuthorizationContext    = require('./dist/impl/AuthorizationContext').AuthorizationContext;
exports.AuthorizationHolder     = require('./dist/impl/AuthorizationHolder').AuthorizationHolder;
exports.Role                    = require('./dist/impl/Role').Role;
exports.Account                 = require('./dist/impl/Account').Account;




//////////////////
// WEBPACK FOOTER
// ./node_modules/janux-authorize/index.js
// module id = JNg7
// module chunks = 0